import { Link2, CheckCircle2, AlertTriangle } from 'lucide-react';
import VinculoErp, { EtiquetaVinculo } from './VinculoErp';

/**
 * Etapa obrigatória da Precificação: cada produto da nota precisa corresponder a um produto do ERP.
 * O vínculo é por razão social do fornecedor + código do produto no fornecedor, e fica salvo
 * para as próximas notas desse fornecedor.
 */
export default function CorrespondenciaErp({ nota, itens, onAtualizarItem, avisoErp }) {
  const vinculados = itens.filter(i => i.vinculo).length;
  const completo = vinculados === itens.length;
  const fornecedor = { cnpj: nota.emitente.cnpj, nome: nota.emitente.nome };

  return (
    <div className={`bg-white rounded-xl border-2 p-5 space-y-3 ${completo ? 'border-green-300' : 'border-blue-300'}`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Link2 className={`w-5 h-5 ${completo ? 'text-green-600' : 'text-blue-600'}`} />
          <div>
            <h3 className="font-semibold text-gray-900">Corresponder produtos da nota ao ERP</h3>
            <p className="text-xs text-gray-500">
              Cada produto de {nota.emitente.nome} precisa apontar para um produto do cadastro do ShopControl.
              O vínculo fica salvo para as próximas notas deste fornecedor.
            </p>
          </div>
        </div>
        <span className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-semibold ${completo ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
          {completo ? <CheckCircle2 className="w-4 h-4" /> : null}
          {vinculados} de {itens.length} correspondidos
        </span>
      </div>

      {avisoErp && (
        <p className="flex items-center gap-1 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-2 py-1">
          <AlertTriangle className="w-3.5 h-3.5" /> {avisoErp}
        </p>
      )}

      <ul className="divide-y divide-gray-100">
        {itens.map(item => (
          <li key={item.indice} className="py-3 grid grid-cols-1 lg:grid-cols-5 gap-3">
            <div className="lg:col-span-2 min-w-0">
              <div className="flex items-center gap-2">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-100 text-xs font-semibold text-gray-700 flex-shrink-0">
                  {item.indice + 1}
                </span>
                <p className="text-sm font-medium text-gray-900 truncate" title={item.descricao}>{item.descricao}</p>
              </div>
              <p className="mt-1 text-xs text-gray-500 flex flex-wrap items-center gap-2 pl-8">
                <span>Cód. fornecedor <span className="font-mono">{item.codigo}</span></span>
                <span>EAN <span className="font-mono">{item.ean || 'sem GTIN'}</span></span>
                <EtiquetaVinculo item={item} />
              </p>
            </div>
            <div className="lg:col-span-3">
              <VinculoErp item={item} fornecedor={fornecedor} onAtualizar={onAtualizarItem} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
